import TextInput from './TextInput';
import { TextInputProps, TextInputValueProps } from './types';

export type { TextInputProps, TextInputValueProps };
export default TextInput;
